<template>

	<div class="process-body">
		<div class="topimg"></div>
		<div class="processbottom">
			<div class="processcontent">
				<div class="content-left">
					<div class="title">大赛流程</div>
					<div style="height: 530px;padding: 30px 20px;">
					  <el-steps direction="vertical" :active="ProcessIndex" process-status='process'>
						  <el-step @click.native="stepFun(index)" v-for="(item,index) in Process" :title="item.ProcessName+'('+item.ProcessTime+')'" :key='item.Id' :description='item.Descript'></el-step>
					  </el-steps>
					</div>
				</div>
				<div class="content-right">
					<div class="title">{{title}}</div>
					<div class="Content" style="color: #333;height: 535px;overflow: scroll">
						<div v-show="Content == 0" class="button-box">
							<button class="personalbtn" @click="registrants()">个人报名</button>
							<button class="teambtn" @click="Shutdown()">团队报名</button>
						</div>
            <img style="width: 100%;" :src="FullPhtoto" alt="">
						<!-- <img v-show="Content == 1" style="width: 100%;" src="../assets/process/初赛.png" alt="">
						<img v-show="Content == 0" style="width: 100%;" src="../assets/process/报名.png" alt=""> -->
					</div>
				</div>
			</div>
		</div>
		<teamSign v-on:downfun='downfun' v-if='down'></teamSign>
		<IndividualEditor  v-on:Indguanbi='Indguanbi' v-if='isshow'></IndividualEditor>
		<v-login v-on:guanbi='guanbi' v-on:bindSuccess='bindSuccess' v-if="login"></v-login>
	</div>

</template>

<script>
	import IndividualEditor from '@/components/common/IndividualEditor'
	import teamSign from '@/components/common/teamSign'
	import vLogin from '@/components/common/login'
	export default {
		data() {
		  return {
			  isshow:0,
			  login:0,
			  down:0,
			  UserInfo:Object,
			title:"",
			Process:[],
			Content:0,
      FullPhtoto:'',
			ProcessIndex:0,
		  };
		},
		created(){
			this.getProcess()
			this.getmember()
		},
		components: {teamSign,vLogin,IndividualEditor},
		methods:{
			guanbi:function(guanbi){
				this.login = guanbi
			},
			Indguanbi:function(Indguanbi){
				this.isshow  = Indguanbi
				this.getmember()
			},
			bindSuccess:function(guanbi){
				this.login = guanbi
			},
			downfun:function(down){
				this.down = down
			},
			Shutdown(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				console.log(this.UserInfo.UserName)
				if(competition_info){
					if(this.UserInfo.UserName){
						if(competition_info.RegistType == 1||competition_info.RegistType == 2){
							this.$confirm('你已报名，请前往个人中心进行线上学习或答题！', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$router.push('/myteam')
							})
						}else{
							this.down = 1
						}
					}else{
						this.$confirm('请先完善个人信息！', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(()=>{
							this.isshow = 1
						})
					}
				}else{
					this.$confirm('请先登录再报名！', '提示', {
						confirmButtonText: '确定',
						type: 'warning'
					}).then(() => {
						this.login = 1
					})
				}

			},
			getmember(){
				this.axios.get('/api/member/GetMember')
				.then(res => {
						this.UserInfo = res.data.data
				})
				.catch(error => {
				  console.log(error)
				})
			},
			registrants(){
				var competition_info = JSON.parse(localStorage.getItem('competition_info'))
				if(competition_info){
					console.log(this.UserInfo.UserName)
					if(this.UserInfo.UserName){
						if(competition_info.RegistType == 1||competition_info.RegistType == 2){
							this.$confirm('你已报名，请前往个人中心进行线上学习或答题！', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$router.push('/myteam')
							})
						}else{
							this.$confirm('个人参赛将不能参加团队比赛，请确认是否报名！', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								console.log(111)
								this.axios.post('/api/CompetitionRegist/PesonRegist')
								.then(res => {
										if(res.data.Success){
											this.$message({
											  message: '报名成功,请前往个人中心进行线上学习或答题！',
											  type: 'success'
											});
											this.RegistType = 2
											var competition_info = JSON.parse(localStorage.getItem('competition_info'))
											competition_info.RegistType = 2
											localStorage.setItem("competition_info",JSON.stringify(competition_info))
										}else{
											this.$message({
											  message: res.data.ErrorMsg,
											  type: 'error'
											});
										}
								})
								.catch(error => {
								  console.log(error)
								})
							})

						}
					}else{
						this.$confirm('请先完善个人信息！', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						}).then(()=>{
							this.isshow = 1
						})
					}
				}else{
					this.$confirm('请先登录再报名！', '提示', {
						confirmButtonText: '确定',
						type: 'warning'
					}).then(() => {
						this.login = 1
					})
				}
			},
			getProcess(){
				this.axios.get("/api/CompetitionProcess/GetList?pageIndex=1&pageSize=200")
				.then(res=>{
					this.Process = res.data.data
          this.FullPhtoto = res.data.data[0].FullPhtoto
					console.log(this.Process)
					this.Content = 0
					for(let x in this.Process){
						console.log(this.Process[x].IsCurrent)
						if(this.Process[x].IsCurrent){
							this.ProcessIndex = Number(x)
						}
					}
					this.title = this.Process[0].ProcessName+'('+this.Process[0].ProcessTime+')'
				})
			},
			stepFun(index){
				console.log(index)
				if(index < this.ProcessIndex){
					this.Content = index
          this.FullPhtoto = this.Process[index].FullPhtoto
					this.title = this.Process[index].ProcessName+'('+this.Process[index].ProcessTime+')'
				}

			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.process-body {
		.topimg{
			width: 100%;
			height: 300px;
			background: url("../assets/3.jpg") no-repeat 0 -20px;
			background-size: 100% 150%;
		}
		.processbottom{
			width: 100%;
			height: 700px;
			background: url("../assets/map.png") #ececec no-repeat center center;
			background-size: 100% 100%;
			padding: 50px 0;
			.processcontent{
				width: 900px;
				margin: 0 auto;
				height: 600px;
				.content-left{
					width: 280px;
					height: 100%;
					background: #fff;
					float: left;
				}
				.content-right{
					width: 590px;
					height: 100%;
					background: #fff;
					float: right;
					.Content{
						color: #333;
						position: relative;
						.button-box{
							position: absolute;
							text-align: center;
							width: 100%;
							bottom: 10px;
							button {
								padding: 5px 20px;
								color: #ab886b;
								border: 1px solid #ab886b;
								border-radius: 5px;
							}

							.personalbtn {
								background: #ab886b;
								color: #fff;
								margin-right: 60px
							}
						}
					}
				}
				.title{
					font-size: 18px;
					height: 65px;line-height: 65px;background: #3e1976;padding-left: 20px; box-sizing: border-box;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/process.vue